import { createElementBlock as o, openBlock as l, createElementVNode as e } from "vue";
import a from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, m, f, i) {
  return l(), o("svg", n, t[0] || (t[0] = [
    e("path", {
      fill: "currentColor",
      d: "m7.102 4.257.01.001a.752.752 0 0 1 .346.148l.072.064 3 3a.75.75 0 0 1-.976 1.133L9.47 8.53 7.75 6.811V19a.75.75 0 0 1-1.493.102L6.25 19V6.811l-1.72 1.72a.75.75 0 0 1-.976.072L3.47 8.53a.75.75 0 0 1-.073-.976l.073-.084 3-3 .072-.064a.753.753 0 0 1 .012-.01l-.084.074A.753.753 0 0 1 7 4.25h.006l.096.007ZM17 4.25a.75.75 0 0 1 .743.648L17.75 5v12.189l1.72-1.72a.75.75 0 0 1 .976-.072l.084.073a.75.75 0 0 1 .073.976l-.073.084-3 3a.754.754 0 0 1-.081.071l.081-.07a.753.753 0 0 1-.854.146.706.706 0 0 1-.206-.147l-3-3a.75.75 0 0 1 .976-1.133l.084.073 1.72 1.719V5a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ a(r, [["render", s]]);
export {
  u as default
};
